import React from "react";
import MemberModal from "./components/MemberModal";

const HumanPractices = ({ fontSize }) => {
  return (
    <div>
      {" "}
      <div>
        <div className="designDiv membersDiv">
          <div className="cardContainer grid-container">
            <MemberModal
              class="grid-item"
              name="Aaisha Ameen "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biochemistry "
              term="3A "
              bird="Early Bird "
              lab="Incubator "
              travel="Japan "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/aaisha-ameen-profile.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/aaisha-ameen-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Anthony Dang "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biochemistry "
              term="3B "
              bird="Night Owl "
              lab="A hot water bath because I'm wet"
              travel="Paris, France "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/anthony-dang-profile.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/anthony-dang-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Bethany Chan "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biochemistry "
              term="2B "
              bird="I am the bird "
              lab="Mohr pipette "
              travel="Away "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/bethany-chan-profile.jpeg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/bethany-chan-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Braeden MacDougall "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Nanotechnology Engineering "
              term="3B "
              bird="Perpetually Tired "
              lab="Dynamic Light Scattering (DLS) Instrument  "
              travel="Japan "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/braede-macdougall-profile.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/braeden-macdougall-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="David Felipe Tello Yepes"
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Microbiology"
              term="4B"
              bird="Early Bird"
              lab="Electronic pipette controller"
              travel="The Antarctic"
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/david-felipe-tello-yepes-profile.jpeg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/david-felipe-tello-yepes-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Jacob March "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biomedical Engineering "
              term="2A "
              bird="Night Owl "
              lab="Centrifuge "
              travel="Iceland "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/jacob-march-profile.jpeg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/jacob-march-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Janessa Tang "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Honors Science "
              term="2A "
              bird="Night Owl "
              lab="Stirring rod "
              travel="Japan, Seoul, Bali "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/j-tang-profile.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/j-tang-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Jessica Zhang "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Computer Science "
              term="4B "
              bird="Night Owl "
              lab=" "
              travel=" "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/jessica-zhang-profile.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/jessica-zhang-profile.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Kritika Grover "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biochemistry with Bioinformatics option "
              term="3B "
              bird="Perpetually Tired "
              lab="Round-bottom flask "
              travel="Mauritius "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/kritika-grover-1.jpg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/kritika-grover-silly.jpg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Naomi Thomas "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biomedical Engineering "
              term="2B "
              bird="Perpetually Tired "
              lab=" "
              travel="Across Europe "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/naomi-thomas-profile.jpeg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/naomi-thomas-profile.jpeg "
              }
            />

            <MemberModal
              class="grid-item"
              name="Rajosree Paul "
              font={{ fontSize: `${20 + fontSize}px` }}
              subteam="Lab & Design"
              program="Biology "
              term="3B "
              bird="Perpetually Tired "
              lab="Inoculation loop "
              travel="The Great Barrier Reef "
              pic={
                "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rajosree-paul-profile.jpeg "
              }
              altPic={
                "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/rajosree-paul-silly.jpeg "
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HumanPractices;
